import { render } from "./organizationUser.vue?vue&type=template&id=0d38d0ca&scoped=true"
import script from "./organizationUser.vue?vue&type=script&lang=js"
export * from "./organizationUser.vue?vue&type=script&lang=js"

import "./organizationUser.vue?vue&type=style&index=0&id=0d38d0ca&lang=scss&scoped=true"
import "./organizationUser.vue?vue&type=style&index=1&id=0d38d0ca&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d38d0ca"]])

export default __exports__